import { useState, useEffect } from 'react';
import { Header } from '@vms/Header';
import Button from '@components/Button';
import { Table } from '@components/Table';
import { IconMoveUp, IconTrash } from '@svg';
import useTableQuickSearch from '@core/hooks/useTableQuickSearch';
import SurveyItemsFilters from '@components/SurveyItemsFilters';
import { SurveyDetailsItem } from '@core/api/useSurveys';

import useSurveyAddItems from './useSurveyAddItems';
import AddItemsTableConfig from './AddItemsTableConfig';
import { BulkItemsAction } from '@pages/SurveyAddItems/BulkItemsConfirmPopup';

const SurveyAddItems = () => {
    const {
        filters,
        actions,
        data,
        isAvailableItemsLoading
    } = useSurveyAddItems();

    const [filteredAvailableItems, setFilteredAvailableItems] = useState<SurveyDetailsItem[]>(data.availableItems ?? []);
    
    // Update filtered items when data changes
    useEffect(() => {
        setFilteredAvailableItems(data.availableItems ?? []);
    }, [data.availableItems]);
    
    const includedItems = useTableQuickSearch(data.includedItems, (s) => s.itemName);

    return (
        <div className="SurveyAddItems">
            <div className="SurveyAddItems__name">Survey Name: {data?.surveyData?.customName}</div>

            <Header
                style={{ marginBottom: '16px' }}
            >
                <div className="SurveyAddItems__section-title">included items</div>
            </Header>
            <div className="SurveyAddItems__table-container">
                <AddItemsTableConfig
                    data={includedItems.searchResults ?? []}
                    action={BulkItemsAction.REMOVE}
                    actionCallback={actions.onRemoveIncludedItem}
                    actionIcon={<IconTrash color="#FFA533" />}
                    newIncludedItemsIds={data.newIncludedItems.flatMap((i) => (i?.id ? [i.id] : []))}
                >
                    <Table rowsCount={includedItems.searchResults?.length ?? 0} isLoading={data?.surveyData === null} />
                </AddItemsTableConfig>
            </div>

            <div className="SurveyAddItems__section-title" style={{ marginBottom: '20px' }}>
                Available items
            </div>
            <Header
                style={{ marginBottom: '16px' }}
            >
                <SurveyItemsFilters
                    items={data.availableItems ?? []}
                    countryId={data?.surveyData?.countryId ?? 0}
                    enableDateRange={true}
                    onDateRangeChange={(startDate, endDate) => {
                        filters.setStartDate(startDate);
                        filters.setEndDate(endDate);
                    }}
                    onFilteredItemsChange={setFilteredAvailableItems}
                />
            </Header>
            <div className="SurveyAddItems__table-container is-full-height">
                <AddItemsTableConfig
                    data={filteredAvailableItems}
                    action={BulkItemsAction.ADD}
                    actionCallback={actions.onIncludeNewItem}
                    actionIcon={<IconMoveUp />}
                >
                    <Table
                        rowsCount={filteredAvailableItems.length}
                        isLoading={isAvailableItemsLoading}
                    />
                </AddItemsTableConfig>
            </div>

            <div className="SurveyAddItems__footer">
                <Button modifiers={['naked']} onClick={() => actions.onNavigateToSurveyDetails()}>
                    Cancel
                </Button>
                <Button onClick={() => actions.onSaveIncludedItems()}>Save selections</Button>
            </div>
        </div>
    );
};

export default SurveyAddItems;
